import { AppBar, Box, Container, Typography, Divider } from '@mui/material';
import styles from './Footer.module.css';

const Footer = () => {
  const footerLinks = [
    { label: 'Lifetouch', link: 'https://lifetouch.com/' },
    { label: 'Terms of use', link: 'https://lifetouch.com/terms-conditions' },
    { label: 'Privacy Policy', link: 'https://lifetouch.com/privacy' },
  ];

  return (
    <AppBar position='sticky'>
      <Container maxWidth='lg'>
        <Box className={styles.footerBox}>
          <Box className={styles.footerLinks}>
            {footerLinks.map((link, index) => (
              <div key={link.label} className={styles.footerLinkItem}>
                <a key={link.link} href={link.link} target='blank'>
                  <Typography
                    key={link.label}
                    variant='subtitle2'
                    color='white'
                  >
                    {link.label}
                  </Typography>
                </a>
                {index !== footerLinks.length - 1 && (
                  <Divider
                    key={'divider_' + link.link}
                    sx={{
                      height: '60%',
                      alignSelf: 'center',
                      borderWidth: 1,
                      m: 1,
                    }}
                    orientation='vertical'
                    color='white'
                    variant='middle'
                    flexItem
                  />
                )}
              </div>
            ))}
          </Box>
          <Box className={styles.footerCopyRight}>
            <Typography variant='subtitle2' color='white' textAlign={'center'}>
              ©2022 Shutterfly Lifetouch, Inc. All Rights Reserved.
            </Typography>
          </Box>
        </Box>
      </Container>
    </AppBar>
  );
};

export default Footer;
